import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  getProducts,
  deleteProduct,
  apiClient,
  bulk_product,
  getcategorybasesubcategory,
  getCategory,
  getSubCategory,
  getSuppliers,
  getManufacturers,
  getWarehouses,
  updateProduct,
  createProduct,
  getTax,
  getUnits,
  getProductDetail,
  createCategory,
  createSubCategory,
  updateProductQty,
  undoDeleteProduct,
  postGeneralData,
  getProductInfo
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import ProductForm from "./Form";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { WarehouseContext } from "../../../Utility/UserContext";
import {
  CommonCardUi,
  InputField,
  SelectOption,
  TextArea,
} from "../../Common/CommonCard";
import { getFormattedCurrentDate2, isReadonlyRoute, NaviGate, validateDates } from "../../../Utility/function";
import { saveAs } from "file-saver";
import SupplierForm from "../Suppliers/form";
import Productqty from "./Productqty";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useLocation, useNavigate } from "react-router-dom";


const storageTypes = [
  { id: "static_shelving", title: "Static Shelving" },
  { id: "mobile_shelving", title: "Mobile Shelving" },
  { id: "pallet_racking", title: "Pallet Racking" },
  { id: "multi_tier_racking", title: "Multi-Tier Racking" },
  { id: "mezzanine_flooring", title: "Mezzanine Flooring" },
  { id: "wire_partitions", title: "Wire Partitions & Cages" },
  { id: "cold_storage", title: "Cold Storage & Temperature-Controlled Storage" },
  { id: "bulk_storage", title: "Bulk Storage" }
];

const Product_list = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, showdeleteModal] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 10;
  const [supplier, setSupplier] = useState([]);
  const [Manufacturers, setManufacturers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const { selectedWarehouse, shopItem, showLoader, hideLoader, UserItem } = useContext(WarehouseContext);
  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [user, setUser] = useState(UserItem);

  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const fileInputRef = useRef(null);
  const [ProductUnit, setProductUnit] = useState([]);
  const [TaxUnit, setTaxUnit] = useState([]);
  const [cardShow, setCardShow] = useState(0);

  const [formData, setFormData] = useState({
    cat_id: "",
    subcat_id: "",
    product_name: "",
    descriptions: "",
    warehouse_id: selectedWarehouse?.id,
    shop_id: shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
    status: "1",
    tax_commodity: "",
    storage_type: "",
    barcode: "",
    box_bar_code: "",
    reorder_point: "",
    box_qty: "",
  });

  const [productQuantityData, setProductQuantityData] = useState({
    product_id: "",
    warehouse_id: selectedWarehouse?.id,
    user_id: user.user_id,
    in_or_out: "0",
    qty: "",
    status: "",
    // date: "",
    supplier_id: "",
    manufacturer_id: "",
    // brand_id: "",
    remaining: "",
    manufacturing_date: "",
    expiry_date: "",
    purchase_unit: "",
    purchase_price: "",
    sales_unit: "",
    sales_price: "",
    box_sales_cost: "",
    created_by: UserItem?.user_id || "0",
    shop_id: shopItem?.shop_id || "0",
    warranty: ''
  });

  const [warehouse, setWarehouses] = useState([]);
  const [editButton, setEditButton] = useState(false);
  const [errors, setErrors] = useState({});
  const [Modal, setModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(false);

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    setSelectedFile(selectedFile);
  };

  const handlesubmit = async (event) => {

    if (!selectedFile) {
      alert("Please Select a File First!");
      return;
    }
    setLoad(true);
    const UPData = new FormData();
    UPData.append("file", selectedFile);
    UPData.append("ware_id", selectedWarehouse?.id);
    UPData.append("user_id", user?.user_id);
    UPData.append("shop_id", shopItem?.shop_id || "0");

    try {
      showLoader();
      const response = await bulk_product(UPData);
      hideLoader();
      fetchProducts();
      toast.success("File uploaded successfully!");
      setModal(false);
      setFormData({
        product_name: "",
        cat_id: "",
        subcat_id: "",
        descriptions: "",
        warehouse_id: selectedWarehouse?.id,
        status: "1",
        storage_type: "",
        tax_commodity: "",
      });
      setSelectedFile(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input value
      }
      setLoad(false);
      setCurrentPage(1);
    } catch (error) {
      setLoad(false);
      setCurrentPage(1);
      setSelectedFile(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input value
      }

      toast.error("Error uploading file.");
      setModal(false);
      hideLoader();
    }
  };

  useEffect(() => {
    fetchCategory();
    fetchSuppliers();
    fetchManufacturers();
    fetchTaxUnit();
    fetchProductUnit();
    fetchWarehouse();
    if (!selectedWarehouse?.id) {
      toast.warning("Select a Warehouse before Entry");
    }
  }, []);

  const fetchWarehouse = async () => {
    try {
      const response = await getWarehouses();
      if (response.data && response.data.data) {
        setWarehouses(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  useEffect(() => {
    if (formData.cat_id) {
      fetchSubCategory();
    }
  }, [formData.cat_id]);


  useEffect(() => {
    fetchProducts();
  }, [selectedWarehouse]);


  const Handledeletemodule = (ID) => {
    showdeleteModal(true);
    setDeleteID(ID);
  };
  const [showSupplierModal, setshowSupplierModal] = useState(false);

  const closeModal1 = () => {
    setShowModal(false);
    setshowSupplierModal(false);
  };

  const fetchSuppliers = async () => {
    try {
      const response = await getSuppliers();
      if (response.data && response.data.data) {
        setSupplier(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const fetchManufacturers = async () => {
    try {
      const response = await getManufacturers();
      if (response.data && response.data.data) {
        setManufacturers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Customers data:", error);
    }
  };

  const fetchProducts = async (page = 1, search = "") => {
    showLoader();
    try {
      const response = await getProducts(search, page, selectedWarehouse?.id);
      // const response = await getProducts(page, selectedWarehouse?.id);
      if (response.data && response.data.data) {
        setProducts(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader();
      }
    } catch (error) {
      toast.error("Error fetching products");
      hideLoader();
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await getCategory();
      if (response.data && response.data.data) {
        // setCategory(response.data.data);
        const cate = response.data.data
        setCategory(cate.filter(cat => cat.status == null || cat.status == 0));
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  const fetchSubCategory = async () => {
    try {
      const response = await getcategorybasesubcategory(formData.cat_id);
      if (response.data && response.data.data) {
        const cate = response.data.data
        setSubCategory(cate.filter(cat => cat.status == null || cat.status == 0));
        // setSubCategory(response.data.data);

      }
    } catch (error) {
      console.error("Error fetching subcategory data:", error);
    }
  };

  const fetchTaxUnit = async () => {
    try {
      const response = await getTax();
      if (response.data && response.data.data) {
        setTaxUnit(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching tax unit:", err);
    }
  };

  const fetchProductUnit = async () => {
    try {
      const response = await getUnits();
      if (response.data && response.data.data) {
        setProductUnit(response.data.data);
      }
    } catch (err) {
      console.error("Error, fetching Product Unit:", err);
    }
  };

  const openEdit = async (prod) => {
    openEditModal(prod);
    setCardShow(5);
    // setSelectedProduct(prod);
    // setCardShow(3);
  };

  const openEditModal = async (product) => {
    try {
      if (product) {
        if (product.category_name) {
          setSearchCategoryTerm(product.category_name);
        }
        if (product.subcategory_name) {
          setSearchSubCategoryTerm(product.subcategory_name);
        }

        setFormData({
          cat_id: product.category_id,
          subcat_id: product.subcategory_id,
          product_name: product.product_name,
          reorder_point: product.reorder_point,
          barcode: product.barcode,
          box_bar_code: product.box_bar_code,
          box_qty: product.box_qty,
          tax_commodity: product.tax_commodity,
          storage_type: product.storage_type,
          warehouse_id: selectedWarehouse?.id,
          descriptions: product.descriptions,
          product_code: product.product_code,
          status: product.status,
        });

        setSelectedProduct(product);
        setEditButton(true);
        setCardShow(1);
      }
    } catch (err) {
      console.error("Error, fetching Product Unit:", err);
    }
  };
  const openEditModalOld = async (prod, qty_id) => {
    try {
      const response = await getProductDetail(prod.product_id, qty_id);
      if (response.data && response.data.product && response.data.qty) {
        var product = response.data.product;
        var productqty = response.data.qty;
        if (prod.category_name) {
          setSearchCategoryTerm(prod.category_name);
        }
        if (prod.subcategory_name) {
          setSearchSubCategoryTerm(prod.subcategory_name);
        }

        setFormData({
          cat_id: product.cat_id,
          subcat_id: product.subcat_id,
          product_name: product.product_name,
          reorder_point: product.reorder_point,
          barcode: product.barcode,
          box_bar_code: product.box_bar_code,
          box_qty: product.box_qty,
          tax_commodity: product.tax_commodity,
          storage_type: product.storage_type,
          warehouse_id: productqty.warehouse_id || selectedWarehouse?.id,
          descriptions: product.descriptions,
          product_code: product.product_code,
          status: product.status,
        });

        setProductQuantityData({
          product_id: prod.product_id,
          product_qty_id: productqty.id,
          supplier_id: productqty.supplier_id,
          manufacturer_id: productqty.manufacturer_id,
          purchase_unit: productqty.purchase_unit,
          sales_unit: productqty.sales_unit,
          qty: productqty.qty,
          purchase_price: productqty.purchase_price,
          sales_price: productqty.sales_price,
          box_sales_cost: productqty.box_sales_cost,
          manufacturing_date: productqty.manufacturing_date,
          expiry_date: productqty.expiry_date,
          status: productqty.status,
          remaining: productqty.qty,
          user_id: UserItem?.user_id || "0",
          brand_id: "1",
          in_or_out: "0",
          shop_id: shopItem?.shop_id || "0",
          created_by: UserItem?.user_id || "0",
          warehouse_id: productqty.warehouse_id || selectedWarehouse?.id,
        });

        setSelectedProduct(prod);
        setEditButton(true);
        setCardShow(1);
      }
    } catch (err) {
      console.error("Error, fetching Product Unit:", err);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  const handleDelete = async () => {
    try {
      await deleteProduct(DeleteID);
      toast.error("Product is  Inactivated ");
      fetchProducts(currentPage);
      showdeleteModal(false);
    } catch (error) {
      toast.error("Error deleting product");
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchProducts(pageNumber);
  };

  const handleDownload = () => {
    console.log("Download button clicked");
    window.location.href = "assets/pdf/demo_products.xlsx";
  };

  const handleExport = async () => {
    try {
      const response = await getProducts(null, "", selectedWarehouse?.id);
      console.log("API Response:", response);

      if (!response.data || !response.data.data || response.data.data.length === 0) {
        toast.warning("No products to export");
        return;
      }

      const products = response.data.data;

      const headers = ["S.No", "Name", "Category", "SubCategory", "Box Barcode", "Remaining"];
      const dataRows = products.map((product, index) => [
        index + 1,
        product.product_name || "N/A",
        product.category_name || "N/A",
        product.subcategory_name || "N/A",
        product.box_bar_code || "N/A",
        product.total_remaining ?? 0
      ]);

      const doc = new jsPDF();

      // Add a title
      doc.text("Product List", 14, 15);

      // Add the table
      autoTable(doc, {
        head: [headers],
        body: dataRows,
        startY: 20,
      });

      // Save the PDF
      doc.save("product_list.pdf");

      toast.success("Products exported successfully");
    } catch (error) {
      console.error("Error exporting products:", error);
      toast.error("Failed to export products.");
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    if (name === "cat_id") {
      filterSubcategories1(value);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const [maxwarranty, setMaxWarranty] = useState()


  const handleChangequantity = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    const numericValue = parseInt(value);
    if (name === "warranty" && numericValue > maxwarranty) {
      return;
    }
    setProductQuantityData({
      ...productQuantityData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name == "qty") {
      if (value > 0) {
        const qty = parseInt(value);
        const serials = handleSerialNumberGeneration(qty);
        setFormData(prev => ({
          ...prev,
          serial_number: serials
        }));
      }
    }
    if (name === "manufacturing_date" || name === "expiry_date") {
      const manufacturedDate = name === "manufacturing_date" ? value : productQuantityData.manufacturing_date;
      const expiryDate = name === "expiry_date" ? value : productQuantityData.expiry_date;
      const warranty = calculateWarrantyMonths(manufacturedDate, expiryDate);
      console.log(warranty);
      setMaxWarranty(warranty)

      setProductQuantityData((prev) => ({
        ...prev,
        [name]: value,
        warranty: warranty,
      }));
      return;
    }
  };
  const calculateWarrantyMonths = (manufactured_date, expiry_date) => {
    if (!manufactured_date || !expiry_date) return "";

    const mDate = new Date(manufactured_date);
    const eDate = new Date(expiry_date);

    if (isNaN(mDate.getTime()) || isNaN(eDate.getTime()) || eDate <= mDate) {
      return "";
    }

    const yearDiff = eDate.getFullYear() - mDate.getFullYear();
    const monthDiff = eDate.getMonth() - mDate.getMonth();
    const dayDiff = eDate.getDate() - mDate.getDate();

    let months = yearDiff * 12 + monthDiff;

    if (dayDiff < 0) {
      // Not a complete extra month
      return `${months + 1}`;
    } else if (dayDiff === 0) {
      return `${months}`;
    } else {
      return `${months + 1}`;
    }
  };

  const filterSubcategories1 = async (categoryId) => {
    try {
      const response = await getcategorybasesubcategory(categoryId);
      if (response.data && response.data.data) {
        console.log("response", response.data);
        const Filterdate = response.data.data;
        setFilteredSubcategories(Filterdate);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const [searchCategoryTerm, setSearchCategoryTerm] = useState();
  const [searchSubCategoryTerm, setSearchSubCategoryTerm] = useState();
  const filteredCategory = searchCategoryTerm
    ? category.filter((item) =>
      item.Categories.toLowerCase().includes(searchCategoryTerm.toLowerCase())
    )
    : category;
  const filteredSupCategory = searchSubCategoryTerm
    ? subcategory.filter((item) =>
      item.subcategory_name
        .toLowerCase()
        .includes(searchSubCategoryTerm.toLowerCase())
    )
    : subcategory;

  const fields = (
    <>
      <div className="col-lg-6 col-12">
        <div className="mb-1 d-flex align-items-centerr">
          <label className="form-label col-4 mb-0 text-verysmall">
            Category
          </label>
          <div className="dropdown col-8">
            <input
              className="w-100 text-verysmall"
              type="text"
              name="cat_id"
              placeholder="Search Category"
              value={searchCategoryTerm}
              onChange={(e) => {
                setSearchCategoryTerm(e.target.value);
              }}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />

            <button
              type="button"
              className="btn btn-sm d-flex align-items-center justify-content-center position-absolute top-50 end-0 translate-middle-y mb-2"
              onClick={() => setShowModal1(true)}
              style={{ border: "none", background: "transparent" }} >
              <i className="bi bi-plus-circle fs-6  text-primary "></i>
            </button>

            <ul
              className="dropdown-menu w-50"
              style={{ maxHeight: "300px", overflowY: "scroll" }}
              aria-labelledby="dropdownMenuButton"
            >
              {filteredCategory.map((item) => (
                <li key={item.id}>
                  <a
                    className="dropdown-item "
                    onClick={() => {
                      if (item.id) {
                        filterSubcategories1(item.id);
                        setSearchCategoryTerm(item.Categories);
                        setFormData({
                          ...formData,
                          ["cat_id"]: item.id,
                        });
                        setErrors((prev) => ({
                          ...prev,
                          cat_id: "",
                        }));
                      }
                    }}
                  >
                    {item.Categories}
                  </a>
                </li>
              ))}
            </ul>

          </div>

        </div>
        <div className="text-center">
          {errors.cat_id && (
            <small className="text-danger fw-end">Category is required.</small>
          )}
        </div>

        <div className="mb-1 d-flex align-items-center">
          <label className="form-label col-4 mb-0 text-verysmall">
            Sub Category
          </label>
          <div className="dropdown col-8">
            <input
              className="w-100 text-verysmall"
              type="text"
              placeholder="Search Sub Category"
              value={searchSubCategoryTerm}
              onChange={(e) => setSearchSubCategoryTerm(e.target.value)}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />

            <button
              type="button"
              className="btn btn-sm position-absolute top-50 end-0 translate-middle-y"
              onClick={() => setShowModal2(true)}
              style={{ border: "none", background: "transparent" }} >
              <i className="bi bi-plus-circle fs-6 text-primary"></i>
            </button>

            <ul
              className="dropdown-menu w-50"
              style={{ maxHeight: "300px", overflowY: "scroll" }}
              aria-labelledby="dropdownMenuButton"
            >
              {filteredSupCategory.map((item) => (
                <li key={item.subcategory_id}>
                  <a
                    className="dropdown-item "
                    onClick={() => {
                      if (item.subcategory_id) {
                        setSearchSubCategoryTerm(item.subcategory_name);
                        setFormData({
                          ...formData,
                          ["subcat_id"]: item.subcategory_id,
                        });
                        setErrors((prev) => ({
                          ...prev,
                          subcat_id: "",
                        }));
                      }
                    }}
                  >
                    {item.subcategory_name}
                  </a>
                </li>
              ))}
            </ul>

            {errors.subcat_id && (
              <small className="text-danger mx-2">SubCategory is required.</small>
            )}
          </div>
        </div>

        {InputField(
          "Product",
          "product_name",
          "text",
          formData.product_name,
          handleChange,
          "Enter Name",
          12,
          null,
          errors.product_name
        )}

        {InputField(
          "Reorder Point",
          "reorder_point",
          "number",
          formData.reorder_point,
          handleChange,
          "Enter Point",
          12,
          null,
          errors.reorder_point
        )}
        <div className="border p-1 bg-body-tertiary">
          {InputField(
            "Product Barcode",
            "barcode",
            "text",
            formData.barcode,
            handleChange,
            "Enter Product Barcode",
            12,
            null,
            errors.barcode
          )}

          {InputField(
            "Product Qty",
            "qty",
            "number",
            productQuantityData.qty,
            handleChangequantity,
            "Enter Quantity",
            12,
            null,
            errors.qty
          )}

          {InputField(
            "Product Purchase Price",
            "purchase_price",
            "number",
            productQuantityData.purchase_price,
            handleChangequantity,
            "Enter Purchase Price",
            12,
            null,
            errors.purchase_price
          )}

          {InputField(
            "Product Sales Price",
            "sales_price",
            "number",
            productQuantityData.sales_price,
            handleChangequantity,
            "Enter Sales Price",
            12,
            null,
            errors.sales_price
          )}
        </div>

        <div className="border mt-1 p-1 bg-body-tertiary">
          {InputField(
            "Box Barcode",
            "box_bar_code",
            "text",
            formData.box_bar_code,
            handleChange,
            "Enter Box Barcode",
            12,
            null,
            errors.box_bar_code
          )}

          {InputField(
            "Box Qty",
            "box_qty",
            "number",
            formData.box_qty,
            handleChange,
            "Enter Box Qty",
            12,
            null,
            errors.box_qty
          )}

          {InputField(
            "Box Sales Cost",
            "box_sales_cost",
            "number",
            productQuantityData.box_sales_cost,
            handleChangequantity,
            "Enter Box Sales Cost",
            12,
            null,
            errors.box_sales_cost
          )}
        </div>
      </div>

      <div className="col-lg-6 col-12">
        {selectedProduct == null && (<></>)}

        {SelectOption(
          "Tax Commodity",
          "tax_commodity",
          formData.tax_commodity,
          handleChange,
          "Select Tax Commodity",
          TaxUnit,
          errors.tax_commodity
        )}

        {SelectOption(
          "Storage Type",
          "storage_type",
          formData.storage_type,
          handleChange,
          "Select Storage Type",
          storageTypes,
          errors.storage_type
        )}

        {SelectOption(
          "Warehouse",
          "warehouse_id",
          productQuantityData.warehouse_id,
          handleChangequantity,
          "Select warehouse",
          warehouse,
          errors.warehouse_id
        )}

        <div className="position-relative">
          {/* SelectOption Component */}
          {SelectOption(
            "Suppliers",
            "supplier_id",
            productQuantityData.supplier_id,
            handleChangequantity,
            "Select Supplier",
            supplier.filter(supplier => supplier.status != 2),
          )}

          {/* Add Supplier Button */}
          <button
            type="button"
            className="btn btn-sm d-flex align-items-center justify-content-center position-absolute top-50 end-0 translate-middle-y"
            onClick={() => setshowSupplierModal(true)}
            style={{ border: "none", background: "transparent" }}
          >
            <i className="bi bi-plus-circle fs-6 mx-3 text-primary"></i>
          </button>
        </div>
        <div className="text-center">
          {errors.supplier_id && (
            <small className="text-danger">{errors.supplier_id}</small>
          )}
        </div>
        {SelectOption(
          "Manufacturer",
          "manufacturer_id",
          productQuantityData.manufacturer_id,
          handleChangequantity,
          "Select Manufacturer",
          Manufacturers,
          errors.manufacturer_id
        )}

        {SelectOption(
          "Purchase Unit",
          "purchase_unit",
          productQuantityData.purchase_unit,
          handleChangequantity,
          "Select Purchase Unit",
          ProductUnit,
          errors.purchase_unit
        )}

        {SelectOption(
          "Sales Unit",
          "sales_unit",
          productQuantityData.sales_unit,
          handleChangequantity,
          "Select Sales Unit",
          ProductUnit,
          errors.sales_unit
        )}

        {InputField(
          "Manufacturer Date",
          "manufacturing_date",
          "date",
          productQuantityData.manufacturing_date,
          handleChangequantity,
          "Enter Date",
          12,
          null,
          errors.manufacturing_date,
          getFormattedCurrentDate2()
        )}

        {InputField(
          "Expiry Date",
          "expiry_date",
          "date",
          productQuantityData.expiry_date,
          handleChangequantity,
          "Enter Date",
          12,
          null,
          errors.expiry_date,
          null,
          null,
          productQuantityData.manufacturing_date || getFormattedCurrentDate2()

        )}
        {InputField(
          "Warranty (Months)",
          "warranty",
          "number",
          productQuantityData.warranty,
          handleChangequantity,
          "Enter warranty",
          12,
          null,
          null,
          maxwarranty,
          false,
          1
        )}

        {TextArea(
          "Description",
          "descriptions",
          "text",
          formData.descriptions,
          handleChange,
          "Enter Description",
          12,
          true
        )}
      </div>
    </>
  );

  const handleclear = () => {
    setFormData({
      cat_id: "",
      subcat_id: "",
      product_name: "",
      descriptions: "",
      warehouse_id: selectedWarehouse?.id,
      status: "1",
      tax_commodity: "",
      storage_type: "",
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
      barcode: "",
      box_bar_code: "",
      reorder_point: "",
      box_qty: "",
    });
    setProductQuantityData({
      product_id: "",
      warehouse_id: selectedWarehouse?.id,
      user_id: user.user_id,
      in_or_out: "0",
      qty: "",
      status: "",
      // date: "",
      supplier_id: "",
      manufacturer_id: "",
      // brand_id: "",
      remaining: "",
      manufacturing_date: "",
      expiry_date: "",
      purchase_unit: "",
      purchase_price: "",
      sales_unit: "",
      sales_price: "",
      box_sales_cost: "",
      created_by: UserItem?.user_id || "0",
      shop_id: shopItem?.shop_id || "0",
    });
    setEditButton(false);
    setSearchSubCategoryTerm("")
    setSearchCategoryTerm("")
    setErrors({});
  };

  const handleCloseqty = () => {
    setCardShow(0)
  };

  const handleUpdate = async (e) => {
    console.log(JSON.stringify(formData))
    console.log(JSON.stringify(productQuantityData))
    showLoader();
    const validationErrors = {};
    for (const key in formData) {
      if (
        key === "storage_type" ||
        key === "descriptions" ||
        key === "box_qty" ||
        key == "warehouse_id"
      ) {
        continue;
      }
      if (!formData[key]) {
        validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      hideLoader();
      setErrors(validationErrors);
      console.log(validationErrors);
      return;
    }

    try {
      await updateProduct(selectedProduct?.product_id, formData);
      var qtypayload = productQuantityData;
      qtypayload.remaining = productQuantityData.qty;
      await updateProductQty(productQuantityData?.product_qty_id, productQuantityData);
      toast.success("Product updated successfully");
      setCardShow(0);
      setSelectedProduct(null);
      handleclear();
      hideLoader();
      fetchProducts();
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || "Error saving product");
        hideLoader();
      } else {
        toast.error("Error saving product");
      }
    }
  };

  const handleSubmit = async (e, addoredit) => {
    console.log(JSON.stringify(formData))
    console.log(JSON.stringify(productQuantityData))
    showLoader();
    const validationErrors = {};
    for (const key in formData) {
      if (
        key === "storage_type" ||
        key === "descriptions" ||
        key === "barcode" ||
        key === "box_qty" ||
        key === "box_sales_cost" ||
        key == "warehouse_id"
      ) {
        continue;
      }

      if (
        // key === "cat_id" ||
        key === "product_name" ||
        key === "reorder_point" ||
        key == "storage_type"
      ) {
        if (!formData[key]) {
          validationErrors[key] = `${key.replace(/_/g, " ")} is required.`; // Generate error message dynamically
        }
      }
    }

    if (addoredit == 0) {
      for (const key in productQuantityData) {
        if (
          key === "remaining" ||
          key === "remark" ||
          key === "product_id" ||
          key === "item_code" ||
          key === "expiry_date" ||
          key == "status" ||
          key == "warehouse_id" ||
          key === "box_qty" ||
          key === "box_sales_cost"
          // key == "cat_id" ||
          // key == "subcat_id"
        ) {
          continue;
        }

        if (
          key === "qty" ||

          key === "supplier_id" ||
          key === "purchase_unit" ||
          key === "purchase_price" ||
          key === "sales_unit" ||
          key === "sales_price" ||
          key === "manufacturing_date" ||
          key == "expiry_date"
        ) {
          if (!productQuantityData[key]) {
            validationErrors[key] = `${key.replace(/_/g, " ")} is required.`; // Generate error message dynamically
          }
        }
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      hideLoader();
      setErrors(validationErrors);
      console.log(formData);
      console.log(productQuantityData);
      console.log(validationErrors);
      return;
    }

    if (productQuantityData.expiry_date) {
      var error = validateDates(productQuantityData.manufacturing_date, productQuantityData.expiry_date, 'Manufacturing', 'Expiry', true);
      if (error) {
        toast.error(error);
        hideLoader();
        return;
      }
    }

    var item = formData;
    item.warehouse_id = productQuantityData.warehouse_id;

    const payload = {
      product: item,
      product_quantity: productQuantityData,
    };
    console.log("createproduct", payload)
    try {
      if (addoredit == 1) {
        await updateProduct(
          selectedProduct?.product_id,
          addoredit == 0 ? payload : formData
        );
        hideLoader();
        toast.success("Product updated successfully");
        setCardShow(0);
      } else {
        const response = await createProduct(payload);
        console.log("Product purchase", response)
        const totalPurchaseAmount = Number(productQuantityData.purchase_price || 0) * Number(productQuantityData.qty || 0);
        const generalDataPayload = {
          type: "3",
          ref_id: "PRO_" + response?.data?.product?.id || "",
          remarks: "Opening Stock",
          date: getFormattedCurrentDate2(),
          created_by: UserItem?.user_id,
          shop_id: shopItem?.id || "0",
          amount: totalPurchaseAmount,
          is_debit: "1",
        };

        await postGeneralData(generalDataPayload);

        const generalDataPayload1 = {
          type: "2",
          ref_id: "Bank_" + response?.data?.product?.id || "",
          remarks: "Bank - To opening stock",
          date: getFormattedCurrentDate2(),
          created_by: UserItem?.user_id,
          shop_id: shopItem?.id || "0",
          amount: totalPurchaseAmount,
          is_debit: "0",
        };

        await postGeneralData(generalDataPayload1);

        hideLoader();
        toast.success("Product added successfully");
        setCardShow(0);
      }
      setSelectedProduct(null);
      setSearchCategoryTerm();
      setSearchSubCategoryTerm();
      handleclear();
      hideLoader();
      fetchProducts();
    } catch (error) {
      console.log(error)
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || "Error saving product");
        hideLoader();
      } else {
        toast.error("Error saving product");
      }
    }
  };

  const [load, setLoad] = useState(false);

  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [transferQty, setTransferQty] = useState(0);
  const [transferWH, setTransferWH] = useState("");

  const handleTransfer = () => {
    setOpenTransferModal(false);
  };

  const [showModal1, setShowModal1] = useState(false);
  const handleSubmit1 = async (e) => {
    e.preventDefault();
    showLoader();

    if (!formData.category.trim()) {
      setErrors({ category: "Category title is required." });
      hideLoader();
      return;
    }

    const payload = {
      Categories: formData.category,
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
    };

    try {
      await createCategory(payload);
      hideLoader();
      toast.success("Category Added Successfully");

      // Close Modal & Refresh List
      setShowModal1(false);
      fetchCategory();
    } catch (error) {
      hideLoader();
      console.error("Error Adding Category:", error?.response?.data?.message);
      toast.error(error?.response?.data?.message || "Failed to add category");
    }
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleclear1 = () => {
    setShowModal1(false);
    setErrors({
      category: "",
    });
    setFormData({
      category: "",
    });
  };

  //sub category 
  const [showModal2, setShowModal2] = useState(false);
  const [formData2, setFormData2] = useState({
    subcategory: '', category_id: '',
    shop_id: shopItem?.shop_id || "0", created_by: UserItem?.user_id || "0",
  });

  useEffect(() => {
    fetchCategory();
    fetchSubCategory();
  }, []);


  const handleSubmit2 = async (e) => {
    e.preventDefault();
    showLoader();

    const validationErrors = {};
    // if (!formData2.category_id) {
    //   validationErrors.category_id = "Category is required.";
    // }
    // if (!formData2.subcategory) {
    //   validationErrors.subcategory = "Subcategory title is required.";
    // }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      return;
    }

    const payload2 = {
      subcategories: formData2.subcategory,
      cat_id: formData2.category_id,
      created_by: UserItem?.user_id || "0",
      shop_id: shopItem?.shop_id || "0",
    };

    try {
      await createSubCategory(payload2);
      hideLoader();
      toast.success('Sub Category Added successfully');
      fetchSubCategory();
      handleCancel2();
      setShowModal2(false);
      fetchSubCategory();
    } catch (error) {
      console.error('Error adding subcategory:', error);
      toast.error(error?.response?.data?.message || "Failed to add subcategory");
      hideLoader();
    }
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData2({ ...formData2, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCancel2 = () => {
    setShowModal2(false);
    setFormData2({ subcategory: '', category_id: '' });
    setErrors({});
  };

  const handleSearch = async (search) => {
    fetchProducts(1, search);
    setCurrentPage(1)
  }

  const undoDelete = async (id) => {
    try {
      const res = await undoDeleteProduct(id);
      console.log(res);
      toast.success('Product is Activated')
      fetchProducts(currentPage)
    } catch (err) {
      console.error(err);
    }
  }

  const [showSerialModal, setShowSerialModal] = useState(false);
  const [serialNumbers, setSerialNumbers] = useState([]);

  const handleSerialNumberGeneration = (qty) => {
    const baseSerial = Date.now(); // Using timestamp as base
    const newSerials = [];

    for (let i = 1; i <= qty; i++) {
      newSerials.push(`${baseSerial}-${i}`);
    }

    setSerialNumbers(newSerials);
    return newSerials;
  };

  const onHandleSubmit = (e, addoredit) => {
    const validationErrors = {};
    for (const key in formData) {
      if (
        key === "storage_type" ||
        key === "descriptions" ||
        key === "barcode" ||
        key === "box_qty" ||
        key === "box_sales_cost" ||
        key == "warehouse_id"
      ) {
        continue;
      }

      if (
        // key === "cat_id" ||
        key === "product_name" ||
        key === "reorder_point" ||
        key == "storage_type"
      ) {
        if (!formData[key]) {
          validationErrors[key] = `${key.replace(/_/g, " ")} is required.`; // Generate error message dynamically
        }
      }
    }

    if (addoredit == 0) {
      for (const key in productQuantityData) {
        if (
          key === "remaining" ||
          key === "remark" ||
          key === "product_id" ||
          key === "item_code" ||
          key === "expiry_date" ||
          key == "status" ||
          key == "warehouse_id" ||
          key === "box_qty" ||
          key === "box_sales_cost" 
          // key == "cat_id" ||
          // key == "subcat_id"
        ) {
          continue;
        }

        if (
          key === "qty" ||

          key === "supplier_id" ||
          key === "purchase_unit" ||
          key === "purchase_price" ||
          key === "sales_unit" ||
          key === "sales_price" ||
          key === "manufacturing_date" ||
          key == "expiry_date"
        ) {
          if (!productQuantityData[key]) {
            validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
          }
        }
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      hideLoader();
      setErrors(validationErrors);
      console.log(formData);
      console.log(productQuantityData);
      console.log(validationErrors);
      return;
    }

    if (productQuantityData.expiry_date) {
      var error = validateDates(productQuantityData.manufacturing_date, productQuantityData.expiry_date, 'Manufacturing', 'Expiry', true);
      if (error) {
        toast.error(error);
        hideLoader();
        return;
      }
    }

    setShowSerialModal(true);
  };

  const editfields = (
    <>
      <div className="col-lg-6 col-12">
        <div className="mb-1 d-flex align-items-centerr">
          <label className="form-label col-4 mb-0 text-verysmall">
            Category
          </label>
          <div className="dropdown col-8">
            <input
              className="w-100 text-verysmall"
              type="text"
              name="cat_id"
              placeholder="Search Category"
              value={searchCategoryTerm}
              onChange={(e) => {
                setSearchCategoryTerm(e.target.value);
              }}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />

            <button
              type="button"
              className="btn btn-sm d-flex align-items-center justify-content-center position-absolute top-50 end-0 translate-middle-y mb-2"
              onClick={() => setShowModal1(true)}
              style={{ border: "none", background: "transparent" }} >
              <i className="bi bi-plus-circle fs-6  text-primary "></i>
            </button>

            <ul
              className="dropdown-menu w-50"
              style={{ maxHeight: "300px", overflowY: "scroll" }}
              aria-labelledby="dropdownMenuButton"
            >
              {filteredCategory.map((item) => (
                <li key={item.id}>
                  <a
                    className="dropdown-item "
                    onClick={() => {
                      if (item.id) {
                        filterSubcategories1(item.id);
                        setSearchCategoryTerm(item.Categories);
                        setFormData({
                          ...formData,
                          ["cat_id"]: item.id,
                        });
                        setErrors((prev) => ({
                          ...prev,
                          cat_id: "",
                        }));
                      }
                    }}
                  >
                    {item.Categories}
                  </a>
                </li>
              ))}
            </ul>

          </div>
        </div>
        <div className="text-center">
          {errors.cat_id && (
            <small className="text-danger fw-end">Category is required.</small>
          )}
        </div>

        <div className="mb-1 d-flex align-items-center">
          <label className="form-label col-4 mb-0 text-verysmall">
            Sub Category
          </label>
          <div className="dropdown col-8">
            <input
              className="w-100 text-verysmall"
              type="text"
              placeholder="Search Sub Category"
              value={searchSubCategoryTerm}
              onChange={(e) => setSearchSubCategoryTerm(e.target.value)}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />

            <button
              type="button"
              className="btn btn-sm position-absolute top-50 end-0 translate-middle-y"
              onClick={() => setShowModal2(true)}
              style={{ border: "none", background: "transparent" }} >
              <i className="bi bi-plus-circle fs-6 text-primary"></i>
            </button>

            <ul
              className="dropdown-menu w-50"
              style={{ maxHeight: "300px", overflowY: "scroll" }}
              aria-labelledby="dropdownMenuButton"
            >
              {filteredSupCategory.map((item) => (
                <li key={item.subcategory_id}>
                  <a
                    className="dropdown-item "
                    onClick={() => {
                      if (item.subcategory_id) {
                        setSearchSubCategoryTerm(item.subcategory_name);
                        setFormData({
                          ...formData,
                          ["subcat_id"]: item.subcategory_id,
                        });
                        setErrors((prev) => ({
                          ...prev,
                          subcat_id: "",
                        }));
                      }
                    }}
                  >
                    {item.subcategory_name}
                  </a>
                </li>
              ))}
            </ul>

            {errors.subcat_id && (
              <small className="text-danger mx-2">SubCategory is required.</small>
            )}
          </div>
        </div>

        {InputField(
          "Product",
          "product_name",
          "text",
          formData.product_name,
          handleChange,
          "Enter Name",
          12,
          null,
          errors.product_name
        )}

        {InputField(
          "Reorder Point",
          "reorder_point",
          "number",
          formData.reorder_point,
          handleChange,
          "Enter Point",
          12,
          null,
          errors.reorder_point
        )}

        <div className="border p-1 bg-body-tertiary">
          {InputField(
            "Product Barcode",
            "barcode",
            "text",
            formData.barcode,
            handleChange,
            "Enter Product Barcode",
            12,
            null,
            errors.barcode
          )}
        </div>

        <div className="border mt-1 p-1 bg-body-tertiary">
          {InputField(
            "Box Barcode",
            "box_bar_code",
            "text",
            formData.box_bar_code,
            handleChange,
            "Enter Box Barcode",
            12,
            null,
            errors.box_bar_code
          )}

          {InputField(
            "Box Qty",
            "box_qty",
            "number",
            formData.box_qty,
            handleChange,
            "Enter Box Qty",
            12,
            null,
            errors.box_qty
          )}
        </div>
      </div>

      <div className="col-lg-6 col-12">
        {selectedProduct == null && (<></>)}

        {SelectOption(
          "Tax Commodity",
          "tax_commodity",
          formData.tax_commodity,
          handleChange,
          "Select Tax Commodity",
          TaxUnit,
          errors.tax_commodity
        )}

        {SelectOption(
          "Storage Type",
          "storage_type",
          formData.storage_type,
          handleChange,
          "Select Storage Type",
          storageTypes,
          errors.storage_type
        )}

        {TextArea(
          "Description",
          "descriptions",
          "text",
          formData.descriptions,
          handleChange,
          "Enter Description",
          12,
          true
        )}
      </div>
    </>
  );

  const handleUpdateNew = async (e) => {
    console.log(JSON.stringify(formData))
    showLoader();
    const validationErrors = {};
    for (const key in formData) {
      if (
        key === "cat_id" ||
        key === "product_name" ||
        key === "reorder_point"
      ) {
        if (!formData[key]) {
          validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
        }
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      hideLoader();
      setErrors(validationErrors);
      console.log(validationErrors);
      return;
    }

    try {
      await updateProduct(selectedProduct?.product_id, formData);
      toast.success("Product updated successfully");
      setCardShow(0);
      setSelectedProduct(null);
      handleclear();
      hideLoader();
      fetchProducts();
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || "Error saving product");
        hideLoader();
      } else {
        toast.error("Error saving product");
      }
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Product List</h6>
          {!readonly && <button
            type="button"
            onClick={() => {
              setCardShow(cardShow == 0 ? 1 : 0);
              if (cardShow == 1) handleclear();
              {
                setErrors({});
                setSelectedProduct(null);
              }
            }}
            className="btn btn-primary mb-0 text-normal rounded-1"
          >
            {cardShow == 0 ? "Add Product" : "Close"}
          </button>}
        </div>
        <hr className='mt-1' />

        {cardShow == 1 && (
          <CommonCardUi
            feilds={fields}
            onSave={(e) => onHandleSubmit(e, 0)}
            // onSave={(e) => handleSubmit(e, 0)}
            onUpdate={(e) => handleUpdate(e, 1)}
            onCancel={() => handleclear()}
            editbutton={editButton}
          />
        )}

        <div>
          {cardShow == 0 && (
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center mb-3">
                  {/* Search Bar */}
                  <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
                    <div className="d-flex position-relative" style={{ width: "100%" }}>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search..."
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                      <img
                        src="/assets/images/icons/search.png"
                        alt="Search Icon"
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          height: "18px",
                          pointerEvents: "none",
                        }}
                      />
                    </div>
                  </div>
                  {/* Buttons Section */}
                  <div className="col-12 col-md-6 col-lg-8 d-flex justify-content-md-end align-items-center">
                    <div className="d-flex flex-column align-items-md-end me-2">
                      {!readonly && (<button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setModal(true)}>
                        <i className="bi bi-upload"></i> Upload File
                      </button>)}
                      {/* Modal */}
                      <div
                        className={`modal fade ${Modal ? "show" : ""}`}
                        tabIndex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden={!Modal}
                        style={{ display: Modal ? "block" : "none" }}
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="exampleModalLabel"
                              >
                                Upload CSV File
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setModal(false)}
                                ref={fileInputRef}
                              ></button>
                            </div>
                            <div className="modal-body">
                              <div className="mb-3">
                                <label
                                  htmlFor="csvFile"
                                  className="text-small form-label"
                                >
                                  Upload CSV / Excel File
                                </label>
                                <input
                                  type="file"
                                  id="csvFile"
                                  className="form-control text-small"
                                  accept=".csv, .xls, .xlsx"
                                  onChange={handleFileChange}
                                  ref={fileInputRef} // Attach ref here
                                />
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                                onClick={() => setModal(false)}
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                disabled={load}
                                onClick={handlesubmit}
                              >
                                {load ? "Loading" : "Upload"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      className="btn btn-outline-success btn-sm mx-1"
                      onClick={handleDownload}
                    >
                      <i className="bi bi-download"></i> Download
                    </button>
                    <button
                      className="btn btn-outline-info btn-sm"
                      onClick={handleExport}
                    >
                      <i className="bi bi-box-arrow-up-right"></i> Export
                    </button>
                  </div>
                </div>

                <div className="table-responsive">
                  <table
                    id="example"
                    className="table table-sm table-striped table-bordered align-baseline"
                    style={{ width: "100%", fontFamily: "poppins" }}
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th
                          style={{ width: "190px" }}
                        >Name</th>
                        <th>Product Code</th>
                        <th>Bar Code</th>
                        <th>Box Bar Code</th>
                        <th>Category</th>
                        <th>SubCategory</th>
                        {/* <th>Box Barcode</th> */}
                        <th>Remaining</th>
                        <th>S.No</th>
                        <th>Performance</th>
                        <th>Transfer</th>
                        {!readonly && <th>Actions</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {products.length > 0 ? (
                        products.map((product, index) => (
                          <tr key={product.product_id}>
                            <td>
                              {(currentPage - 1) * productsPerPage + index + 1}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "breakWord"
                              }}>{product.product_name}</td>
                            <td>{product.product_code}</td>
                            <td>{product?.barcode}</td>
                            <td>{product?.box_bar_code}</td>
                            <td>{product.category_name}</td>
                            <td>{product.subcategory_name}</td>
                            <td>{product.total_serial_count || 0}</td>
                            <td>
                              <>
                                <img
                                  src="/assets/images/icons/view.png"
                                  onClick={() => {
                                    navigate("/product_serial_no", {
                                      state: product,
                                    })
                                  }}
                                  height={"16px"}
                                />
                                {/* &nbsp;&nbsp;&nbsp; */}
                              </>
                            </td>
                            <td>
                              <img
                                src="/assets/images/icons/view.png"
                                onClick={() => {
                                  navigate("/product_performance", {
                                    state: product,
                                  })
                                }}
                                height={"16px"}
                              />
                            </td>
                            <td>
                              <img
                                src="/assets/images/icons/transfer-switch.png"
                                onClick={() => {
                                  navigate("/product-transfer", {
                                    state: product,
                                  })
                                }}
                                height={"16px"}
                              />
                            </td>
                            {!readonly && <td>
                              {product.status != 2 ? (
                                <>
                                  &nbsp;&nbsp;&nbsp;
                                  <img
                                    src="/assets/images/icons/edit.png"
                                    onClick={() => openEdit(product)}
                                    height={"16px"}
                                  />
                                  &nbsp;&nbsp;&nbsp;
                                  <img
                                    src="/assets/images/icons/delete.png"
                                    className="mx"
                                    onClick={() => Handledeletemodule(product.product_id)}
                                    height={"16px"}
                                  />
                                </>
                              ) : (
                                <button className="btn btn-secondary py-1 rounded-1" style={{ fontSize: '13px' }} onClick={() => undoDelete(product?.product_id)}>Inactive</button>
                              )}

                            </td>}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No products found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div
          className={`modal fade ${openTransferModal ? "show" : ""}`}
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden={!openTransferModal}
          style={{ display: openTransferModal ? "block" : "none" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Transfer Product
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setOpenTransferModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="text-small form-label">Warehouse</label>
                  <select
                    className="text-small w-100"
                    style={{ height: "2rem" }}
                    value={transferWH}
                    onChange={(e) => setTransferWH(e.target.value)}
                    required
                  >
                    <option value="" disabled>
                      {"Select warehouse"}
                    </option>
                    {warehouse.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.title || ""}
                      </option>
                    ))}
                  </select>
                  <label className="text-small form-label">Quantity</label>
                  <input
                    type="number"
                    className="form-control text-small"
                    value={transferQty}
                    onChange={(e) => {
                      setTransferQty(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => setOpenTransferModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={load}
                  onClick={() => {
                    handleTransfer();
                  }}
                >
                  Transfer
                </button>
              </div>
            </div>
          </div>
        </div>

        {deleteModal && (
          <Deletemodel
            setShowModal={showdeleteModal}
            handleDelete={handleDelete}
          />
        )}

        {showModal && (
          <ProductForm
            selectedProduct={selectedProduct}
            closeModal={closeModal}
            refreshList={fetchProducts}
          />
        )}

        {showModal1 && (
          <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                    Add Category
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleclear1()}
                  ></button>
                </div>
                <div className="modal-body" style={{ fontFamily: "poppins" }}>
                  <form onSubmit={handleSubmit1}>
                    <div className="form-group mb-3 d-flex align-items-center">
                      <label className="col-3 text-normal">Category</label>
                      <div className="col-8">
                        <input
                          type="text"
                          name="category"
                          value={formData.category}
                          onChange={handleChange1}
                          className="form-control text-normal"
                          required
                        />
                        {errors.category && (
                          <small className="text-danger">{errors.category}</small>
                        )}
                      </div>
                    </div>

                    <div className="mt-5">
                      <button
                        type="submit"
                        className="btn btn-success float-end text-normal rounded-1"
                      >
                        Add Category
                      </button>
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-secondary ml-2 float-end me-1 text-normal rounded-1"
                        onClick={() => handleclear1()}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {showModal2 && (
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add SubCategory</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={handleCancel2}></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit2}>
                    <div className="form-group mb-3">
                      <label>SubCategory</label>
                      <input type="text" name="subcategory" value={formData2.subcategory} onChange={handleChange2} className="form-control" />
                      {errors.subcategory && <small className="text-danger">{errors.subcategory}</small>}
                    </div>
                    <div className="form-group mb-3">
                      <label>Category</label>
                      <select name="category_id" value={formData2.category_id} onChange={handleChange2} className="form-control">
                        <option value="">Select Category</option>
                        {category?.map((cat) => (
                          <option key={cat.id} value={cat.id}>{cat.Categories}</option>
                        ))}
                      </select>
                      {errors.category_id && <small className="text-danger">{errors.category_id}</small>}
                    </div>
                    <button type="submit" className="btn btn-success float-end">Add Sub Category</button>
                    <button type="button" className="btn btn-secondary float-end me-2" onClick={handleCancel2}>Cancel</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {showSupplierModal && (
          <SupplierForm
            // selectedSupplier={selectedSupplier}
            onClose={() => closeModal1()}
            fetchSuppliers={fetchSuppliers}
          />
        )}

        {cardShow == 3 && (
          <Productqty
            selectedProduct={selectedProduct}
            openEditModal={openEditModal}
            handleCloseqty={handleCloseqty}
          />
        )}

        {showSerialModal && (
          <div className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Serial Numbers</h5>
                  <button type="button" className="btn-close" onClick={() => setShowSerialModal(false)}></button>
                </div>
                <div className="modal-body">
                  {serialNumbers.map((serial, index) => (
                    <div key={index} className="mb-2">
                      <label className="form-label">Item {index + 1}</label>
                      <input
                        type="text"
                        className="form-control"
                        value={serial}
                        onChange={(e) => {
                          const newSerials = [...serialNumbers];
                          newSerials[index] = e.target.value;
                          setSerialNumbers(newSerials);
                        }}
                      />
                    </div>
                  ))}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e) => {
                      setFormData(prev => ({
                        ...prev,
                        serial_number: serialNumbers
                      }));
                      setShowSerialModal(false);
                      handleSubmit(e, 0);
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {cardShow == 5 && (
          <CommonCardUi
            feilds={editfields}
            // onSave={(e) => onHandleSubmit(e, 0)}
            onUpdate={(e) => handleUpdateNew(e, 1)}
            onCancel={() => handleclear()}
            editbutton={editButton}
          />
        )}
      </div>
    </div>
  );
};

export default Product_list;
